// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Dics","notes":"Notes_notes__253AP"};